'use client';

import { useLocale } from '@/contexts/LocaleContext';
import { Agenda } from '@/payload-types';
import { getDictionary } from '@/utils/getDictionary';

import styles from './EventAgenda.module.scss';
import { EventAgendaItem } from './EventAgendaItem';

type Props = {
  agenda: Agenda;
};

export const EventAgenda: React.FC<Props> = ({ agenda }) => {
  const locale = useLocale();
  const t = getDictionary(locale);

  if (!agenda?.items || agenda?.items.length === 0) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.label}>{t('events.todaysAgenda')}</h2>
      <div className={styles.list}>
        {agenda.items.map((item, index) => (
          <EventAgendaItem key={index} item={item} />
        ))}
      </div>
      <span className={styles.endLabel}>{t('events.thankYouForToday')}</span>
    </div>
  );
};
